import { render, staticRenderFns } from "./CUNYSandboxTubes.vue?vue&type=template&id=9c0e473a&scoped=true&"
import script from "./CUNYSandboxTubes.vue?vue&type=script&lang=js&"
export * from "./CUNYSandboxTubes.vue?vue&type=script&lang=js&"
import style0 from "./CUNYSandboxTubes.vue?vue&type=style&index=0&id=9c0e473a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0e473a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VContainer,VIcon,VSelect})
